import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withStyles } from "tss-react/mui";
import { CircularProgress, FormControl, MenuItem, Select, Tooltip } from "@mui/material";
import { Close, Delete } from "@mui/icons-material";
import Button from "../../../components/CustomButtons/Button";
import NumberInput from "../../../components/CustomInput/NumberInput";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import * as actions from "../../../store/actions";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

//###
import axios from "axios";
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import SaveButton from "../../../components/CustomInput/SaveButton";
import { __ } from "../../../translations/utils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

export function PayCommissions({ ...props }) {
  const { classes } = props;
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [commisionData, setCommisionData] = useState({});
  const [paymentMethods, setPaymentMethods] = useState([]);

  /**
   * Component did mount
   */
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);

    axios
      .all([
        axios.get("/core/vestigingen/" + props.vestiging_id),
        axios.get("/core/vestigingen/" + props.vestiging_id + "/getpaymethods"),
      ])
      .then(
        axios.spread((payCommisionResponse, paymentMethodsResponse) => {
          setCommisionData(JSON.parse(payCommisionResponse.data.data.payCommissions));
          setPaymentMethods(paymentMethodsResponse.data.data.paymentMethods);

          setLoading(false);
        })
      );
  };

  const inputSelect = paymentMethods
    .filter((method) => {
      return !(method.value in commisionData);
    })
    .map((method) => {
      return (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={method.value}
          value={method.value}
        >
          {method.label}
        </MenuItem>
      );
    });

  const handleChange = (key, field, value) => {
    let intValue = parseInt(value);

    if (isNaN(intValue)) {
      intValue = 0;
    }

    let data = { ...commisionData };
    data[key][field] = intValue;
    setCommisionData(data);
  };

  const handleRemove = (rowKey) => {
    let data = { ...commisionData };
    delete data[rowKey];

    setCommisionData(data);
  };

  const handleAdd = (key) => {
    let data = { ...commisionData };
    data[key] = {
      fixedCosts: 0,
      variableCosts: 0,
    };

    setCommisionData(data);
  };

  const save = () => {
    setSaving(true);

    let data = {
      _method: "PATCH",
      payCommissions: JSON.stringify(commisionData),
    };

    axios.post("core/vestigingen/" + props.vestiging_id, data).then((response) => {
      getData();
      setSaving(false);
    });
  };

  return (
    <div>
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth
        keepMounted
        maxWidth={"lg"}
        onClose={props.toggle}
        open={props.open}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <TranslationWrapper tDefault={"Commissie kosten."} tKey={"payCommisions.header"} />
          </h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          {loading ? (
            <div className={classes.loadingMain}>
              <CircularProgress className={classes.loadingIcon} />
            </div>
          ) : null}

          {!loading ? (
            <div>
              <GridContainer>
                <GridItem className={classes.selectInputGridItem} sm={12} xs={12}>
                  <FormControl className={classes.selectFormControl} fullWidth>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      displayEmpty
                      onChange={(e) => {
                        handleAdd(e.target.value);
                      }}
                      value={""}
                    >
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        disabled
                        key={"empty"}
                        value={""}
                      >
                        <TranslationWrapper
                          tDefault={"Pay commision toevoegen."}
                          tKey={"vestigingen.paycommision.modal.noselect"}
                        />
                      </MenuItem>
                      {inputSelect}
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={5}>
                  <b>Betaal methode</b>
                </GridItem>
                <GridItem xs={3}>
                  <b>Vast kosten (centen)</b>
                </GridItem>
                <GridItem xs={3}>
                  <b>Variable kosten (percentage)</b>
                </GridItem>
                <GridItem xs={1} />
              </GridContainer>

              {Object.keys(commisionData).map((key) => {
                let detail = commisionData[key];

                return (
                  <GridContainer>
                    <GridItem xs={5}>{key}</GridItem>
                    <GridItem xs={3}>
                      <NumberInput
                        decimalen={0}
                        onChange={(e) => {
                          handleChange(key, "fixedCosts", e.value);
                        }}
                        value={detail.fixedCosts}
                      />
                    </GridItem>
                    <GridItem xs={3}>
                      <NumberInput
                        decimalen={0}
                        onChange={(e) => {
                          handleChange(key, "variableCosts", e.value);
                        }}
                        value={detail.variableCosts}
                      />
                    </GridItem>
                    <GridItem xs={1}>
                      {key !== "default" ? (
                        <Tooltip
                          classes={{ tooltip: classes.tooltip }}
                          placement={"bottom"}
                          title={<TranslationWrapper tDefault={"Verwijderen"} tKey={"global.tooltip.remove"} />}
                        >
                          <Button
                            className={classes.actionButton}
                            color={"danger"}
                            onClick={() => {
                              handleRemove(key);
                            }}
                            simple
                          >
                            <Delete className={classes.icon} />
                          </Button>
                        </Tooltip>
                      ) : null}
                    </GridItem>
                  </GridContainer>
                );
              })}
            </div>
          ) : null}
        </DialogContent>
        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <SaveButton
            buttonText={__("timeodds", "modal.timeodds.button.save", "Aanpassingen opslaan")}
            disabled={false}
            key={"savebutton"}
            onClick={save}
            saving={saving}
            type={"button"}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    userLocale: state.user.lang,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) =>
      dispatch({
        type: actions.SHOW_MESSAGE,
        message: message,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PayCommissions, notificationsStyle));
